<template>
  <div class="column content-box settings--content">
    <label
      class="medium-9 columns settings-item"
      :class="{ error: $v.model.$error }"
    >
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABEL_MODEL') }}
      <select v-model="model" @change="$v.model.$touch">
        <option v-for="m in models" :key="m" :value="m">{{ m }}</option>
      </select>
      <span v-if="$v.model.$error" class="message">
        Selecione um modelo
      </span>
    </label>

    <label
      class="medium-9 columns settings-item"
      :class="{ error: $v.instructions.$error }"
    >
      <div class="label-with-button">
        <span>{{
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABEL_INSTRUCTIONS')
        }}</span>
        <woot-button
          type="button"
          class="button--improve-ai"
          color-scheme="secondary"
          variant="smooth"
          size="small"
          :is-loading="isImprovingPrompt"
          :disabled="!instructions || instructions.trim().length === 0"
          @click="improvePromptWithAI"
        >
          <span class="icon-text">
            <span class="icon">✨</span>
            <span>Melhorar com IA</span>
          </span>
        </woot-button>
      </div>
      <div v-if="isImprovingPrompt" class="skeleton-textarea textlong">
        <div v-for="n in 5" :key="n" class="skeleton-line" />
      </div>
      <textarea
        v-else
        v-model.trim="instructions"
        name="instructions"
        class="textlong"
        :placeholder="
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.PLACEHOLDER_INSTRUCTIONS')
        "
        @input="$v.instructions.$touch"
      />
      <span v-if="$v.instructions.$error" class="message">
        {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.ERROR_INSTRUCTIONS') }}
      </span>
    </label>

    <div class="tab-footer">
      <woot-submit-button
        :disabled="$v.$invalid"
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import assistentTabMixin from '../../mixins/assistentTabMixin';
import chatCompletionsAPI from 'dashboard/api/chatCompletions';

const models = [
  'gpt-6-sol',
  'gpt-6-luna',
  'gpt-5.6-sol',
  'gpt-5.6-terra',
  'gpt-5.6-luna',
  'gpt-5.5',
  'gpt-5.4',
  'gpt-5.4-mini',
  'gpt-5.4-nano',
  'gpt-5.2',
  'gpt-5.1',
  'gpt-5-mini',
  'gpt-5-nano',
  'gpt-4.1',
  'gpt-4.1-mini',
  'gpt-4o',
  'gpt-4o-mini',
];

const modelValidate = value => models.includes(value);

export default {
  mixins: [assistentTabMixin],
  data() {
    return {
      models,
      model: this.assistent.model || 'gpt-4o-mini',
      instructions: this.assistent.instructions || '',
      isImprovingPrompt: false,
    };
  },
  validations: {
    model: {
      required,
      modelValidate,
    },
    instructions: {
      required,
      maxLength: maxLength(256000),
    },
  },
  methods: {
    async improvePromptWithAI() {
      if (!this.instructions || this.instructions.trim().length === 0) {
        this.showAlert(
          'Por favor, digite as instruções antes de melhorar com IA'
        );
        return;
      }

      this.isImprovingPrompt = true;
      try {
        const response = await chatCompletionsAPI.improvePrompt(
          this.instructions
        );
        this.instructions = response.data.improved_instructions;
        this.showAlert('Instruções melhoradas com sucesso!');
      } catch (error) {
        this.showAlert('Erro ao melhorar as instruções. Tente novamente.');
      } finally {
        this.isImprovingPrompt = false;
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      await this.saveAssistent({
        model: this.model,
        instructions: this.instructions,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
